<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>favorite</md-icon>
          </div>
          <h4 class="title">Edit Activity Labourer Workplace</h4>
        </md-card-header>

        <form @submit.prevent="update">
          <md-card-content>
            <div class="text-right">
              <md-button @click="goBack" class="md-primary md-dense">
                Back to List
              </md-button>
            </div>

            <select-input-horizontal
                v-model="activityLabourerWorkplace.activity_id"
                :options="activities"
                placeholder="Select Activity"
                label="Activity"
                name="name"
                track-by="id"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.activity_id"
            ></select-input-horizontal>

            <select-input-horizontal
                v-model="activityLabourerWorkplace.labourer_id"
                :options="labourers"
                placeholder="Select Labourer"
                label="Labourer"
                name="name"
                :track-by="'id'"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                @search="labourerFind"
                :error="apiValidationErrors.labourer_id"
            ></select-input-horizontal>

            <select-input-horizontal
                v-model="activityLabourerWorkplace.workplace_id"
                :options="workplaces"
                placeholder="Select Workplace"
                label="Workplace"
                name="name"
                track-by="id"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.workplace_id"
            ></select-input-horizontal>

            <md-datepicker v-model="startDate">
              <label>Select date</label>
            </md-datepicker>
            <validation-error :errors="apiValidationErrors.start_date"/>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button type="submit" class="md-success">Update Assignment</md-button>
          </md-card-actions>
        </form>
      </md-card>
    </div>
  </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import SelectInputHorizontal from '@/components/Inputs/SelectInputHorizontal.vue';
import dayjs from 'dayjs';

export default {
    components: { SelectInputHorizontal, ValidationError },

    mixins: [formMixin],

    data: () => ({

        activityLabourerWorkplace: {
            type: 'activityLabourerWorkplaces',
            request_type: null,
            labourer_count: null,
            activity: {
                id: null,
                type: 'activities',
            },
            labourer: {
                id: null,
                type: 'labourers',
            },
            workplace: {
                id: null,
                type: 'workplaces',
            },
            relationshipNames: ['activity', 'labourer', 'workplace'],
        },
        activities: [],
        labourers: [],
        workplaces: []

    }),

    created () {
        this.get();
        this.getActivities();
        this.getWorkplaces();
        this.getLabourers();
    },
    computed: {
        startDate: {
            get () {
                if (!this.activityLabourerWorkplace.start_date) {
                    return null;
                }
                return dayjs
                    .utc(this.activityLabourerWorkplace.start_date)
                    .tz('Africa/Dar_es_Salaam')
                    .format('YYYY-MM-DD');
            },
            set (value) {
                this.activityLabourerWorkplace.start_date = value;
            }
        }
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('activityLabourerWorkplaces/get', id + '?include=labourer,activity,workplace');
                this.activityLabourerWorkplace = this.$store.getters['activityLabourerWorkplaces/activityLabourerWorkplace'];
                if (this.activityLabourerWorkplace.workplace) {
                    this.activityLabourerWorkplace.workplace_id = this.activityLabourerWorkplace.workplace.id;
                }
                if (this.activityLabourerWorkplace.labourer) {
                    this.activityLabourerWorkplace.labourer_id = this.activityLabourerWorkplace.labourer.id;
                }
                if (this.activityLabourerWorkplace.activity) {
                    this.activityLabourerWorkplace.activity_id = this.activityLabourerWorkplace.activity.id;
                }
            } catch (e) {
                console.log(e);
                this.notifyException(e);
            }
        },

        async update () {
            try {
                await this.$store.dispatch('activityLabourerWorkplaces/update', this.activityLabourerWorkplace);
                await this.$store.dispatch(
                    'alerts/success',
                    'Assignment to workplace Activity updated successfully.'
                );
                this.goBack();
            } catch (e) {
                this.notifyException(e);
                if (e.response && e.response.data && e.response.data.errors[0]) {
                    this.setApiValidation(e.response.data.errors);
                }
            }
        },
        getActivities () {
            this.$store.dispatch('activities/list').then(() => {
                console.log(this.$store);
                this.activities = this.$store.getters['activities/list'];
            });
        },
        getLabourers () {
            this.$store.dispatch('labourers/list').then(() => {
                this.labourers = this.$store.getters['labourers/list'];
            });
        },
        getWorkplaces () {
            this.$store.dispatch('workplaces/list').then(() => {
                this.workplaces = this.$store.getters['workplaces/list'];
            });
        },

        goBack () {
            this.$router.push({ name: 'List Activity Labourer Workplace' });
        },
        async labourerFind (query, id) {
            this.isLoading = true;
            let params = {
                filter: { queryKey: query }
            };
            await this.$store.dispatch('labourers/list', params).then(() => {
                this.labourers = this.$store.getters['labourers/list'];
                this.isLoading = false;
            });
        }
    },
};
</script>
